(function Deals($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$('.btn-call-to-action').click(function trackClick(e) {
			var deal_id       = $('#deal-id').val(),
				hot_deal_link = $(this).data('link');

			e.preventDefault();

			Adzuki.Ajax.post('/Deals/logCallActionClick/', {deal_id})
				.then(function response(data) {
					window.location.href = Adzuki.base_uri + hot_deal_link;
				});
		});

		$('.btn-request-info').click(function trackClick(e) {
			var deal_id       = $('#deal-id').val(),
				hot_deal_link = $(this).data('link');

			e.preventDefault();

			Adzuki.Ajax.post('/Deals/logCallActionClick/', {deal_id})
				.then(function response(data) {
					window.location.href = Adzuki.base_uri + hot_deal_link;
				});
		});
	});
}(jQuery, window.Adzuki || {}));
